import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_PARAMETER } from "./abstract/rootAbstract";

const _action = `${ACTION_PREFIX_PARAMETER}_load`;
const _header = `Load model`;

export const loadModel = (root) => {
  const _payload = loadModelLogic();

  logger.logAction(_action, _payload, ACTION_PREFIX_PARAMETER);

  return { root, info: _payload };
};

const loadModelLogic = () => {
  return generatePayload();
};

//--------------------------------------------------------------------------------

const generatePayload = () => {
  const _payload = {
    group: ActionGroupTypes.ADD,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: `Load model.`,
  };

  return _payload;
};
